import Card from "components/Cards/Card.js";
import { useCallback, useState } from "react";
import Dropzone from "react-dropzone";
import { useStorage } from "reactfire";

function TransactionsUpload() {
  const storage = useStorage();
  const [uploading, setUploading] = useState(false);
  const [uploaded, setUploaded] = useState(false);
  const onUpload = useCallback(
    async (file) => {
      console.log(file);
      setUploading(true);
      const timestamp = Date.now();
      try {
        await storage.ref(`transaction-logs/${timestamp}.pdf`).put(file, {
          contentType: "application/pdf",
        });
        setUploaded(true);
      } finally {
        setUploading(false);
      }
    },
    [storage]
  );
  return (
    <Card title="mBoK Transactions PDF">
      <div className="p-8">
        {uploading ? (
          <Uploading />
        ) : uploaded ? (
          <Uploaded />
        ) : (
          <UploadPDF onUpload={onUpload} />
        )}
      </div>
    </Card>
  );
}

function UploadPDF({ onUpload }) {
  return (
    <Dropzone
      onDropAccepted={(files) => onUpload(files[0])}
      accept="application/pdf"
      multiple={false}
    >
      {({ getRootProps, getInputProps }) => (
        <div
          {...getRootProps({
            className:
              "flex flex-col gap-4 p-4 rounded-xl justify-center items-center border-dashed border-4 border-blueGray-400 text-blueGray-600",
          })}
        >
          <input {...getInputProps()} />
          <span className="text-2xl">
            Drag and drop the PDF file here or click
          </span>
          <i className="fas fa-cloud-upload-alt text-8xl text-blueGray-400" />
        </div>
      )}
    </Dropzone>
  );
}

function Uploading() {
  return (
    <div className="flex flex-col gap-4 p-4 justify-center items-center">
      <span className="text-2xl text-blueGray-600 animate-pulse">
        Uploading file
      </span>
      <i className="fas fa-circle-notch text-8xl text-blueGray-400 animate-spin-slow" />
    </div>
  );
}

function Uploaded() {
  return (
    <div className="flex flex-col gap-4 p-4 justify-center items-center">
      <span className="text-2xl text-emerald-600">File Uploaded</span>
      <i className="fas fa-check-circle text-8xl text-emerald-400" />
    </div>
  );
}

export default TransactionsUpload;
